import * as Yup from 'yup'

export default Yup.object().shape({
  productDescription: Yup.string()
    .required('Required.')
    .min(30, 'Please enter a product idea at least 30 characters long.')
    .max(255)
})
